export interface LanguagePreference {
  language_code: string;
  language_id: string;
  priority: number;
}

export interface CountryLanguageInfo {
  country_code: string;
  languages: LanguagePreference[];
}

export const COUNTRY_LANGUAGE_MAPPING: Record<string, CountryLanguageInfo> = {
  "VN": {
    "country_code": "VN",
    "languages": [
      {
        "language_code": "vi",
        "language_id": "1",
        "priority": 1
      }
    ]
  },
  "US": {
    "country_code": "US",
    "languages": [
      {
        "language_code": "en",
        "language_id": "11703",
        "priority": 1
      }
    ]
  },
  "CN": {
    "country_code": "CN",
    "languages": [
      {
        "language_code": "zh",
        "language_id": "14063",
        "priority": 1
      }
    ]
  },
  "VU": {
    "country_code": "VU",
    "languages": [
      {
        "language_code": "bi",
        "language_id": "13969",
        "priority": 1
      },
      {
        "language_code": "en",
        "language_id": "11703",
        "priority": 2
      },
      {
        "language_code": "fr",
        "language_id": "13987",
        "priority": 2
      }
    ]
  }
}; 